<div
  *ngIf="!isReadCodbar"
  class="pnl-product-detail"
  [class.view]="isView"
  [class.change]="changeDetail"
>
  <header>
    <a (click)="onClose()"><fa-icon [icon]="faChevronLeft"></fa-icon></a>
    <div
      class="btn-option-style"
      (click)="toggleOptions()"
      (mouseout)="hideOptions()"
      [class.open]="optionOpen"
    >
      <fa-icon [icon]="faEllipsisV"></fa-icon>
      <div (mouseover)="clearOptions()" (mouseout)="hideOptions()">
        <a *ngIf="urlproduct != ''" [href]="urlproduct" target="_blank"
          >Página do produto <fa-icon [icon]="faExternalLinkAlt"></fa-icon
        ></a>
        <a (click)="openEditImages()">Editar fotos</a>
        <div>
          <span class="status">
            <div class="ipt-switch">
              <input
                id="ckStatusDetail"
                [(ngModel)]="ckStatus"
                (change)="onChangeDetail()"
                type="checkbox"
                value="S"
                name="status"
              />
              <label for="ckStatusDetail"></label>
            </div>
            <span *ngIf="ckStatus">Ativo</span>
            <span *ngIf="!ckStatus" class="tred strong">Inativo</span>
          </span>
        </div>
      </div>
    </div>
  </header>
  <div>
    <form [formGroup]="produtoFrm" (ngSubmit)="onSubmit()" novalidate>
      <div class="top">
        <figure>
          <img *ngIf="image_sel_src != ''" [src]="image_sel_src" />
        </figure>
        <div class="description">
          <span class="title">{{ descricao.value }}</span>
          <div class="barcode">
            <i><i></i><i></i><i></i></i>
            <strong>{{ codbarra | mask: "0 000000? 000000 000" }}</strong>
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="nav-tab">
          <a (click)="onTabClick('price')" [class.active]="tab == 'price'"
            >Preço</a
          >
          <a (click)="onTabClick('attr')" [class.active]="tab == 'attr'"
            >Atributos</a
          >
          <a
            (click)="onTabClick('department')"
            [class.active]="tab == 'department'"
            >Departamento</a
          >
        </div>

        <div class="detail-wrapper-detail">
          <div
            class="detail-wrapper detail-price"
            [class.dnone]="tab != 'price'"
          >
            <div class="row">
              <label>Preço ao consumidor</label>
              <input
                placeholder="R$ 0,00"
                class="form-style"
                formControlName="preco"
                currencyMask
                (keyup)="onChangePrice()"
              />
              <!-- <a class="link-offer"
                ><fa-icon [icon]="faPlus"></fa-icon> Adicionar oferta?</a
              > -->
              <div
                class="promocao"
                [class.dnone]="product.idproduto_estabelecimento == 0"
              >
                <app-product-offers #productOffersItem></app-product-offers>
              </div>
            </div>

            <div class="row">
              <label>Limite de compras por cliente</label>
              <input
                placeholder="Sem limite"
                formControlName="max_pr_cliente"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                (keyup)="onChangeDetail()"
                class="form-style"
              />
            </div>

            <div class="row">
              <label>Estoque</label>
              <input
                [attr.placeholder]="
                  sem_limite.value ? 'Sem limite' : 'Quantidade em estoque'
                "
                formControlName="estoque"
                (keyup)="onChangeDetail()"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                [attr.disabled]="sem_limite.value ? true : null"
                class="form-style"
              />
              <mat-checkbox
                formControlName="sem_limite"
                (change)="onUnlimitedStock()"
                >Sem limite</mat-checkbox
              >
              <div *ngIf="!sem_limite.value">
                <label>Limite mínimo do estoque</label>
                <input
                  placeholder=""
                  class="form-style"
                  formControlName="limite_minimo_estoque"
                  currencyMask
                  [options]="{ precision: 0, allowNegative: false }"
                  (keyup)="onChangeDetail()"
                />
              </div>
            </div>

            <div class="row">
              <mat-checkbox
                id="ckFrete"
                formControlName="ckFrete"
                (change)="onChangeDetail()"
                >Oferecer frete grátis neste produto</mat-checkbox
              >

              <mat-checkbox
                *ngIf="isAdmin"
                id="ckChangePrice"
                formControlName="ckChangePrice"
                (change)="onChangeDetail()"
                >Permitir o ajuste do preço pelo APP Retaguarda!</mat-checkbox
              >
            </div>
          </div>

          <div class="detail-wrapper detail-attr" [class.dnone]="tab != 'attr'">
            <div class="row">
              <label>Nome sugerido ao produto</label>
              <input
                class="form-style mb10"
                formControlName="descricao"
                (keyup)="onChangeDetail()"
              />
              <label>Subtítulo do produto (opcional)</label>
              <input
                class="form-style"
                formControlName="subtitulo"
                (keyup)="onChangeDetail()"
              />
            </div>

            <div class="row">
              <label>Marca do produto</label>
              <input
                class="form-style no-view"
                formControlName="marca"
                (keyup)="onChangeDetail()"
              />
              <strong class="view">{{ product.marca }}</strong>
            </div>

            <div class="row">
              <label>Peso do produto</label>
              <div class="peso">
                <input
                  type="text"
                  class="form-style"
                  formControlName="peso_liquido"
                  (keyup)="onChangeDetail()"
                  currencyMask
                  placeholder="0"
                /><span
                  ><ng-select
                    [items]="unidades"
                    (change)="onChangeDetail()"
                    (clear)="onChangeDetail()"
                    formControlName="unidade_peso_liquido"
                    placeholder="Selecione"
                    bindLabel="label"
                    bindValue="unidade"
                  ></ng-select
                ></span>
              </div>
            </div>
          </div>

          <div
            class="detail-wrapper detail-department"
            [class.dnone]="tab != 'department'"
          >
            <div class="row">
              <div formArrayName="categories">
                <div
                  *ngFor="let category of categories.controls; let i = index"
                  [formGroupName]="i"
                >
                  <label>Categoria do produto</label>
                  <div class="col">
                    <ng-select
                      *ngIf="
                        categorias.length > 0 &&
                        category.controls.showText.value == false
                      "
                      class="ng-select-visible ng-categoria"
                      formControlName="categoria"
                      [items]="categorias"
                      placeholder="Selecione uma categoria"
                      (change)="onChangeCategoria(category, i)"
                      (clear)="onChangeDepartamento()"
                      bindLabel="ds_categoria"
                      bindValue="idcategoria"
                    ></ng-select>

                    <input
                      *ngIf="
                        categorias.length == 0 ||
                        category.controls.showText.value == true
                      "
                      type="text"
                      class="form-control"
                      placeholder="Preencha com a nova categoria"
                      (keyup)="onChangeDepartamento()"
                      formControlName="categoria"
                    />

                    <button
                      *ngIf="
                        categorias.length > 0 &&
                        category.controls.showText.value == false &&
                        category.controls.categoria.value == null
                      "
                      (click)="newCategory(category)"
                      type="button"
                      class="btn btn-warning-outline"
                    >
                      nova
                    </button>

                    <button
                      *ngIf="
                        categorias.length > 0 &&
                        category.controls.showText.value == true
                      "
                      (click)="newCategory(category)"
                      type="button"
                      class="btn btn-warning-outline"
                    >
                      selecionar
                    </button>

                    <button
                      (click)="removeCategoria(i)"
                      *ngIf="categories.controls.length > 1"
                      type="button"
                      class="btn btn-danger-outline"
                    >
                      remover
                    </button>
                  </div>
                  <div
                    class="pnl-subcategoria"
                    *ngIf="
                      category.controls.subcategorias &&
                      category.controls.subcategorias.controls.length > 0
                    "
                  >
                    <div class="mt20">
                      <label>Subcategoria do produto</label>
                      <app-subcategoria-item
                        [id]="i"
                        [list]="category.controls.list.value"
                        [subcategorias]="category.controls.subcategorias"
                        (onChangeEvent)="onChangeDepartamento()"
                      ></app-subcategoria-item>
                    </div>
                  </div>
                  <div class="pnl-subcategoria">
                    <div class="row">
                      <div class="item-subcategoria">
                        <div class="row mt15">
                          <div class="col">
                            <button
                              (click)="
                                addNewSubcategory(
                                  category.controls.subcategorias
                                )
                              "
                              type="button"
                              class="btn btn-primary-outline btn-new-subcategoria"
                            >
                              Adicionar subcategoria
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <mat-checkbox
                id="ckRefrigerado"
                class="ck-amadurecimento"
                formControlName="refrigerado"
                (change)="onChangeDetail()"
                >Produto refrigerado</mat-checkbox
              >

              <mat-checkbox
                id="ckAmadurecimento"
                class="ck-amadurecimento"
                formControlName="ckAmadurecimento"
                (change)="onChangeDetail()"
                >Permitir a seleção do ponto de amadurecimento</mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <footer>
    <button (click)="onCancelRegister()" class="btn-cancel">Cancelar</button>
    <button (click)="onSubmit()" class="btn-confirm">Salvar</button>
  </footer>
</div>

<div *ngIf="isEditImages" class="pnl-product-image">
  <header>
    <a (click)="closeEditImages()"
      ><fa-icon [icon]="faChevronLeft" class="mr10"></fa-icon> Voltar</a
    >
  </header>
  <ul
    *ngIf="
      (uploader.queue && uploader.queue.length > 0) ||
      (gallery && gallery.length > 0)
    "
    class="galery-queue"
  >
    <li
      *ngFor="let image of gallery; let i = index"
      (click)="selectPhoto(image, i)"
      [class.active]="i == fileImageIdx"
    >
      <img [src]="ajustUrl(image.small + '?' + image.hash)" />
    </li>
    <li
      *ngFor="let item of uploader.queue; let i = index"
      (click)="selectImageView(item, i)"
      [class.active]="i == fileViewIdx"
    >
      <img src="" imgPreview [image]="item?._file" class="c-object" />
    </li>
    <li
      (click)="addMoreImage()"
      *ngIf="
        uploader.queue &&
        uploader.queue.length + gallery.length < 5 &&
        gallery.length < 5
      "
    >
      <i class="ic ic-no-image-small"></i>
    </li>
  </ul>

  <div *ngIf="isFileView || isImageView" class="media-view">
    <figure>
      <img
        *ngIf="isFileView && fileView"
        src=""
        imgPreview
        [image]="fileView?._file"
        class="media-object"
      />
      <img
        *ngIf="isImageView && image_sel_src"
        [src]="ajustUrl(image_sel_src + '?' + image_sel_hash)"
      />
    </figure>
    <div class="subtitle">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="image_subtitle"
        (keyup)="onChangeSubtitle()"
        placeholder="Legenda..."
      />
    </div>
    <div *ngIf="isFileView" class="actions">
      <button
        type="button"
        (click)="onRemoveFileImage(); fileUploader.click()"
        class="btn btn-warning"
      >
        TROCAR IMAGEM
      </button>
      <button
        type="button"
        (click)="onRemoveFileImage()"
        class="btn btn-danger"
      >
        EXCLUIR IMAGEM
      </button>
    </div>
    <div *ngIf="isImageView" class="actions">
      <button
        type="button"
        *ngIf="isImageChange"
        (click)="onChangeImage()"
        class="btn btn-warning"
      >
        TROCAR IMAGEM
      </button>
      <button type="button" (click)="onRemoveImage()" class="btn btn-danger">
        EXCLUIR IMAGEM
      </button>
    </div>
  </div>

  <div
    *ngIf="!isFileView && !isImageView"
    ng2FileDrop
    [uploader]="uploader"
    (fileOver)="fileOverBase($event)"
    class="region-upload"
    [ngClass]="{
      'nv-file-over': hasBaseDropZoneOver,
      'nv-has-galery': gallery.length > 0
    }"
  >
    <i class="ic ic-no-image"></i>
    <strong
      >Arraste e solte aqui até
      {{ 5 - numberPhoto - uploader.queue.length }}
      {{ 5 - numberPhoto - uploader.queue.length > 1 ? "fotos" : "foto" }}
      do produto</strong
    >
    <button
      type="button"
      (click)="fileUploader.click()"
      class="btn btn-primary-outline"
    >
      ou clique aqui para buscar
    </button>
  </div>

  <input
    id="fileUploader"
    #fileUploader
    type="file"
    ng2FileSelect
    [uploader]="uploader"
    class="dnone"
    multiple
  />
</div>

<div *ngIf="isReadCodbar" class="pnl-product-start">
  <header>
    <a (click)="onClose()"><fa-icon [icon]="faTimes"></fa-icon></a>
  </header>
  <div>
    <div class="top">
      <figure>
        <img src="assets/img/read_barcode.jpg" />
      </figure>
      <strong>Adicionar novo produto</strong>
      <div>
        <label>Digite o código de barras do produto</label>
        <input
          id="codbarra"
          class="form-style"
          (keyup)="onKeyCodbarra($event)"
          maxlength="19"
          (keyup.enter)="onSearchProduct()"
          mask="0 000000 000000? 000"
        />
      </div>
    </div>
    <div class="bottom">
      <p>
        Ou leia o código de barras <br />
        apontando a câmera do seu celular
      </p>
      <button (click)="onOpenBarcode()" class="btn-confirm barcode-icon">
        <i><i></i><i></i><i></i></i>Iniciar leitura do código de barras
      </button>
    </div>
  </div>
</div>

<div class="loading" *ngIf="loadingProduct">
  <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
    <div class="ldio-ns36390yc">
      <div></div>
    </div>
  </div>
</div>

<div class="readBarcode" [class.dnone]="!openReaderBarcode">
  <header>
    <a (click)="onCloseReadBarcode()"><fa-icon [icon]="faTimes"></fa-icon></a>
  </header>
  <div id="readBarcode"></div>
</div>
